import React, { useState } from 'react';
import '../Styles/HorizontalToggleButtons.css';

export function HorizontalToggleButtons({ categories = [] }) {
	const [activeCategory, setCategory] = useState(categories[0]?.id);

	if (categories.length === 0) return null;

	return (
		<div className="pill-wrapper">
			<div className="toggle-container">
				{categories.map((cat) => (
					<button
						key={cat.id}
						className={`toggle-btn ${activeCategory === cat.id ? 'active' : ''}`}
						onClick={() => {
							setCategory(cat.id);
							if (cat.action) cat.action();
						}}
					>
						{cat.label}
					</button>
				))}
			</div>
			
			<div className="content-display">
				<div key={activeCategory} className="fade-in">
					{categories.find(c => c.id === activeCategory)?.content}
				</div>
			</div>
		</div>
	);
}